import React, { useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import "../../assets/css/login.scss";

import { Button, Error, Image, Input, Label } from "../../Components";
import Icon from "../../assets/icons/Icon";
import { loginUser } from "../../store/user/user-action";
import { loginSchema } from "../../Schema/LoginSchema";

const Login = () => {
  const dispatch = useDispatch();
  const [showHide, setShowHide] = useState(true);
  const isLoading = useSelector((state) => state.ui?.isLoading);

  const { values, touched, errors, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        user_outo_no: "",
        user_pass_auto: "",
      },
      validationSchema: loginSchema,
      onSubmit: (values) => {
        loginUser(dispatch, values);
      },
    });

  return (
    <>
      <section className="login_app">
        <div className="nebula"></div>
        <div className="login-container">
          <div className="login-header">
            <div className="logo_img">
              <a href="#">
                <Image
                  className="logo_icon"
                  src="/assets/images/logo.svg"
                  alt="logo icon"
                />
              </a>
            </div>
            <p>Log In</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <Label className="form-label" for="user_outo_no">
                Username
              </Label>

              <Icon name="UserCircle" className="icon_box" />

              <Input
                type="text"
                className="form-control"
                id="user_outo_no"
                name="user_outo_no"
                placeholder="Enter username"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.user_outo_no}
                autoFocus={true}
                tabIndex={1}
              />
              {errors.user_outo_no && touched.user_outo_no && (
                <Error>{errors.user_outo_no}</Error>
              )}
            </div>
            <div className="input-group">
              <Label className="form-label" for="user_pass_auto">
                Password
              </Label>
              <Icon name="Lock" className="icon_box" />
              <Input
                type={`${!showHide ? "text" : "password"}`}
                className="form-control"
                name="user_pass_auto"
                id="user_pass_auto"
                placeholder="Enter password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.user_pass_auto}
                autoComplete="on"
                tabIndex={2}
              />

              <div className="eye_icon" onClick={() => setShowHide(!showHide)}>
                {showHide ? <Icon name="Eye" /> : <Icon name="EyeClosed" />}
              </div>
              {errors.user_pass_auto && touched.user_pass_auto && (
                <Error>{errors.user_pass_auto}</Error>
              )}
            </div>
            <div className="input-group">
              <Button
                className="login-button"
                type="submit"
                // icon="FaSignInAlt"
                isDisabled={isLoading}
                tabIndex={3}
              >
                {isLoading ? "Logging in" : "Login"}
              </Button>
            </div>
          </form>
          <div className="form-footer">
            <p>
              This is Trading Application with full trading features, designed
              solely for educational purposes.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
